module.exports = __webpack_public_path__ + "img/per.66e36ea3.png";